/** Bold Subscriptions PDP — prices, legend, frequency dropdown, qty display */
(function () {
  if (window.__pdpAtcPriceInit) return;
  window.__pdpAtcPriceInit = true;

  function moneyFormat() {
    return document.querySelector('product-info')?.dataset.moneyFormat || '${{amount}}';
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return moneyFormat()
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function getVariant() {
    const json = document.querySelector('variant-selects [data-selected-variant]');
    if (json) {
      try {
        return JSON.parse(json.textContent);
      } catch {
        /* fall through to data-price fallback */
      }
    }

    // Featured product sections often have no variant picker — use Liquid price cents.
    const priceEl = document.querySelector('[data-atc-price][data-price]');
    if (priceEl) {
      const price = parseInt(priceEl.getAttribute('data-price'), 10);
      if (!Number.isNaN(price)) return { price };
    }

    return null;
  }

  function getBlockSettings() {
    const el = document.querySelector('[data-bsub-block-settings-json]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch {
      return {};
    }
  }

  function getWidget() {
    return document.querySelector('[data-bsub-widget]');
  }

  function isOneTimeSelected(widget) {
    return !!widget?.querySelector('[data-bsub-purchase-option-one-time]:checked');
  }

  function getSellingPlanAllocation(variant, widget) {
    if (!variant?.selling_plan_allocations?.length) return null;

    const planId = widget?.querySelector('[data-bsub-delivery-frequency-option]:checked')?.value;
    if (planId) {
      const match = variant.selling_plan_allocations.find(
        (a) =>
          String(a.selling_plan_id) === String(planId) ||
          String(a.selling_plan?.id) === String(planId)
      );
      if (match) return match;
    }

    return variant.selling_plan_allocations[0];
  }

  function getSellingPlanPriceCents(variant, widget) {
    if (!variant) return 0;
    return getSellingPlanAllocation(variant, widget)?.price ?? variant.price;
  }

  function getUnitPriceCents(variant, widget) {
    if (!variant) return 0;
    if (!widget || isOneTimeSelected(widget)) return variant.price;
    return getSellingPlanPriceCents(variant, widget);
  }

  function getFrequencyOptionLabel(optionEl) {
    const settings = getBlockSettings();
    const prefixSource = (settings.frequency_text || settings.frequency_header || '').trim();
    let prefix = prefixSource
      ? prefixSource.charAt(0).toUpperCase() + prefixSource.slice(1).replace(/\s*frequency\s*$/i, '').trim()
      : '';

    const name = optionEl.querySelector('.bsub-widget__main-text')?.textContent?.trim() || '';
    let sub = optionEl.querySelector('.bsub-widget__sub-text')?.textContent?.trim() || '';

    if (sub) {
      sub = sub.replace(/\$[\d,.]+/g, '').replace(/\s+/g, ' ').trim();
      const pct = sub.match(/\d+%\s*off/i);
      if (pct) sub = '(' + pct[0] + ')';
    }

    const label = (prefix ? prefix + ' : ' + name : name) + (sub ? ' ' + sub : '');
    return label.replace(/\$[\d,.]+/g, '').replace(/\s+/g, ' ').trim();
  }

  function mountOptionsInSubscribeGroup() {
    const widget = getWidget();
    if (!widget) return;

    const subscribeGroup = widget.querySelector('[data-bsub-selling-plan-group]');
    const container = widget.querySelector('.bsub-options-container');
    if (!subscribeGroup || !container) return;

    if (!subscribeGroup.contains(container)) {
      subscribeGroup.appendChild(container);
      container.querySelector('.bsub-frequency-select-wrap')?.remove();
    }
  }

  function buildFrequencySelectOptions(fieldset) {
    const options = [];
    fieldset.querySelectorAll('.bsub-option-container').forEach((optionEl) => {
      const radio = optionEl.querySelector('[data-bsub-delivery-frequency-option]');
      if (!radio) return;
      options.push({
        value: radio.value,
        label: getFrequencyOptionLabel(optionEl),
        checked: radio.checked,
      });
    });
    return options;
  }

  function setupFrequencyDropdown() {
    mountOptionsInSubscribeGroup();

    const container = document.querySelector('.bsub-options-container');
    const fieldset = container?.querySelector('.bsub-widget__delivery-fieldset');
    if (!container || !fieldset) return;

    const optionData = buildFrequencySelectOptions(fieldset);
    if (!optionData.length) return;

    fieldset.classList.add('bsub__hidden');

    let wrap = container.querySelector('.bsub-frequency-select-wrap');
    let select = container.querySelector('.bsub-frequency-select');

    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'bsub-frequency-select-wrap';
      select = document.createElement('select');
      select.className = 'bsub-frequency-select';
      select.setAttribute(
        'aria-label',
        getBlockSettings().frequency_header || fieldset.querySelector('legend')?.textContent?.trim() || ''
      );
      select.addEventListener('change', function () {
        const radio = fieldset.querySelector(
          '[data-bsub-delivery-frequency-option][value="' + select.value + '"]'
        );
        if (!radio) return;
        radio.checked = true;
        if (window.BOLD?.BsubWidget?.handleSelectionChange) {
          window.BOLD.BsubWidget.handleSelectionChange({ target: radio });
        } else {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateAll();
      });
      wrap.appendChild(select);
      container.insertBefore(wrap, fieldset);
    }

    const current = select.value;
    select.innerHTML = '';
    optionData.forEach(function (opt) {
      const el = document.createElement('option');
      el.value = opt.value;
      el.textContent = opt.label;
      if (opt.checked || opt.value === current) el.selected = true;
      select.appendChild(el);
    });
  }

  function updateOptionPrices(variant) {
    const widget = getWidget();
    variant = variant || getVariant();
    if (!widget || !variant) return;

    widget.querySelectorAll('.bsub-widget__group').forEach(function (group) {
      let priceEl = group.querySelector('[data-pdp-option-price]');
      if (!priceEl) {
        priceEl = document.createElement('span');
        priceEl.className = 'bsub-widget__option-price';
        priceEl.setAttribute('data-pdp-option-price', '');
        group.querySelector('.bsub-widget__group-header')?.appendChild(priceEl);
      }

      if (group.querySelector('[data-bsub-purchase-option-one-time]')) {
        priceEl.textContent = formatMoney(variant.price);
      } else if (group.hasAttribute('data-bsub-selling-plan-group')) {
        priceEl.textContent = formatMoney(getSellingPlanPriceCents(variant, widget));
      }
    });
  }

  function getSelectedOptionLabel(widget) {
    const checked =
      widget.querySelector('[data-bsub-purchase-option-one-time]:checked') ||
      widget.querySelector('[data-bsub-selling-plan-group-input]:checked');
    if (!checked) return '';

    const group = checked.closest('.bsub-widget__group');
    const textEl =
      group?.querySelector('.bsub-widget__text span') || group?.querySelector('.bsub-widget__text');
    return textEl?.textContent?.trim() || '';
  }

  function updateLegend() {
    const widget = getWidget();
    const legend = widget?.querySelector('legend');
    if (!legend) return;

    const settings = getBlockSettings();
    let heading = (settings.header_text || legend.textContent || '').trim();
    if (heading.includes(':')) heading = heading.split(':')[0].trim();
    heading = heading.replace(/:$/, '');

    const label = getSelectedOptionLabel(widget);
    if (!heading || !label) return;

    legend.innerHTML = heading + ': <strong>' + label + '</strong>';
  }

  function updateAtcPrice(variant) {
    const sectionId = document.querySelector('product-info')?.dataset.section;
    const priceTargets = document.querySelectorAll(
      '#ProductSubmitButton-' + sectionId + ' [data-atc-price], sticky-add-to-cart [data-atc-price]'
    );
    if (!priceTargets.length) return;

    variant = variant || getVariant();
    // Keep Liquid-rendered price when we have no variant data (avoid $0.00 overwrite).
    if (!variant) return;

    const widget = getWidget();
    const qtyInput = document.querySelector('#Quantity-' + sectionId);
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    const formattedPrice = formatMoney(getUnitPriceCents(variant, widget) * qty);

    priceTargets.forEach((el) => {
      el.textContent = formattedPrice;
      if (variant.price != null && !el.getAttribute('data-price')) {
        el.setAttribute('data-price', String(variant.price));
      }
    });
  }

  function syncQtyDisplay() {
    document.querySelectorAll('.product-form__quantity--pdp [data-quantity-display]').forEach(function (display) {
      const input = display.closest('quantity-input')?.querySelector('.quantity__input');
      if (input) display.textContent = input.value;
    });
  }

  function splitPaymentOptionsInWrap(wrap) {
    const slot = wrap.querySelector('[data-pdp-more-payment-slot]');
    if (!slot) return false;

    const moreLink = wrap.querySelector('.shopify-payment-button__more-options:not([data-pdp-more-moved])');
    if (!moreLink) return false;

    const isSkeleton = moreLink.classList.contains('shopify-payment-button__skeleton');
    const label = (moreLink.textContent || '').replace(/\u00a0/g, ' ').trim();
    if (isSkeleton && !/more payment/i.test(label)) return false;

    moreLink.setAttribute('data-pdp-more-moved', '');
    slot.appendChild(moreLink);
    return true;
  }

  function splitPaymentOptions(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('[data-pdp-shop-pay]').forEach(splitPaymentOptionsInWrap);
  }

  function observePaymentMoreOptions(root) {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    scope.querySelectorAll('[data-pdp-shop-pay]').forEach(function (wrap) {
      if (wrap.dataset.pdpMoreObserved) return;
      wrap.dataset.pdpMoreObserved = 'true';

      new MutationObserver(function () {
        splitPaymentOptionsInWrap(wrap);
      }).observe(wrap, { childList: true, subtree: true });
    });
  }

  function ensureWidgetVisible() {
    const widget = getWidget();
    if (!widget) return;

    [widget, widget.querySelector('.bsub-widget__wrapper')].forEach(function (el) {
      if (!el) return;
      el.hidden = false;
      el.style.removeProperty('display');
      el.style.removeProperty('visibility');
      el.classList.remove('bsub__hidden');
    });

    const subscribeChecked = widget.querySelector(
      '[data-bsub-selling-plan-group-input]:checked:not([data-bsub-purchase-option-one-time])'
    );
    const container = widget.querySelector('.bsub-options-container');
    if (subscribeChecked && container) {
      container.classList.remove('bsub__hidden');
      container.style.removeProperty('display');
    }
  }

  function restorePurchaseSelection() {
    const widget = getWidget();
    if (!widget) return;

    const hasSelection =
      widget.querySelector('[data-bsub-purchase-option-one-time]:checked') ||
      widget.querySelector('[data-bsub-selling-plan-group-input]:checked');
    if (hasSelection) return;

    const settings = getBlockSettings();
    const subscribeInput = widget.querySelector(
      '[data-bsub-selling-plan-group-input]:not([data-bsub-purchase-option-one-time])'
    );
    const oneTimeInput = widget.querySelector('[data-bsub-purchase-option-one-time]');
    const target =
      settings.default_subscribe !== false && subscribeInput
        ? subscribeInput
        : oneTimeInput || subscribeInput;
    if (!target) return;

    target.checked = true;
    if (window.BOLD?.BsubWidget?.handleSelectionChange) {
      window.BOLD.BsubWidget.handleSelectionChange({ target: target });
    } else {
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function refreshWidgetAfterCart() {
    if (!getWidget()) return;
    ensureWidgetVisible();
    restorePurchaseSelection();
    updateAll();
    splitPaymentOptions();
  }

  function updateAll(variant) {
    ensureWidgetVisible();
    setupFrequencyDropdown();
    updateOptionPrices(variant);
    updateLegend();
    syncQtyDisplay();
    updateAtcPrice(variant);
  }

  document.addEventListener('change', function (event) {
    const t = event.target;
    if (t.closest('[data-bsub-widget]') || t.matches('.quantity__input')) {
      updateAll();
    }
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.product-form__quantity--pdp .quantity__button')) {
      setTimeout(syncQtyDisplay, 0);
    }
  });

  document.addEventListener('product-info:loaded', function (event) {
    const productInfo = event.target;
    splitPaymentOptions(productInfo);
    observePaymentMoreOptions(productInfo);
    [200, 600, 1500, 3000].forEach(function (delay) {
      setTimeout(function () {
        splitPaymentOptions(productInfo);
      }, delay);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateAll();
    splitPaymentOptions();
    observePaymentMoreOptions();
    setTimeout(function () {
      updateAll();
      splitPaymentOptions();
    }, 600);
    [1500, 3000].forEach(function (delay) {
      setTimeout(splitPaymentOptions, delay);
    });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const variant = event.data?.variant;
      updateAll(variant);
      setTimeout(function () {
        updateAll();
        splitPaymentOptions();
        window?.Shopify?.PaymentButton?.init();
        document.querySelector('product-info')?.refreshPdpCheckoutButtons?.();
      }, 200);
      setTimeout(function () {
        splitPaymentOptions();
        window?.Shopify?.PaymentButton?.init();
        document.querySelector('product-info')?.refreshPdpCheckoutButtons?.();
      }, 800);
    });
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      syncQtyDisplay();
      updateAtcPrice();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (!getWidget()) return;
      [100, 400, 1000].forEach(function (delay) {
        setTimeout(refreshWidgetAfterCart, delay);
      });
    });
  }
})();
